export default __webpack_public_path__ + "quick-actions-request-project.748282d2.svg";